import { render } from "./AddFilter.vue?vue&type=template&id=d5f5a7e2"
import script from "./AddFilter.vue?vue&type=script&lang=js"
export * from "./AddFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__